import {DfbSearchSymbol} from '../symbol/Symbol';
import TooltipIconButton from '../tooltip/TooltipIconButton';

type TableFilterProps = {
    id: string,
    children: any
}

const TableFilter = (props: TableFilterProps) => {
    return (
        <TooltipIconButton
            icon={DfbSearchSymbol}
            tooltip={{
                placement: 'bottom',
                distance: 5,
                closeOnClick: false,
                inverted: true
            }}
            onClick={e => e.stopPropagation()}
            tooltipChildren={props.children}
        />
    );
};

export default TableFilter;
